/**
 * Company identity used by the Imprint (§5 DDG), the Privacy Policy
 * (Art. 13 GDPR) and the Terms.
 *
 * SkillSynergy is operated by a sole proprietor (Einzelunternehmer), not a
 * registered company. That is why there is no `representative`, no register
 * court and no HRB number here: §5(1) no. 4 DDG requires those only for
 * entities entered in a commercial, cooperative or association register.
 * Publishing a register entry that does not exist would itself be misleading.
 *
 * A USt-IdNr has been issued, so §27a UStG requires it to be shown.
 */

export const LEGAL = {
  /** Trading name shown to visitors. */
  tradingName: "SkillSynergy",

  /** The natural person operating the service. Required by §5(1) no. 1 DDG. */
  entityName: "Mohamed Handaoui",

  street: "Osdorfer Str. 42",
  postalCode: "12207",
  city: "Berlin",
  country: "Germany",

  /** VAT identification number under §27a UStG. */
  vatId: "DE449643842",

  /** Person responsible for editorial content under §18(2) MStV. */
  contentResponsible: "Mohamed Handaoui",

  email: "contact@skillsynergy.net",
  phone: "+49 151 525 54041",

  /**
   * Competent supervisory authority. Berlin-established controllers fall under
   * the Berlin DPA.
   */
  supervisoryAuthority: {
    name: "Berliner Beauftragte für Datenschutz und Informationsfreiheit",
    url: "https://www.datenschutz-berlin.de",
  },

  /** ISO date of the last substantive change to the privacy policy / terms. */
  lastUpdated: "2026-07-14",
} as const;

/**
 * Guards against shipping an Imprint with unfilled placeholders. Kept even
 * though every value is now supplied: it costs nothing and catches a
 * half-finished edit before it reaches production.
 */
export const LEGAL_DETAILS_COMPLETE = !Object.values(LEGAL).some(
  (value) => typeof value === "string" && value.startsWith("TODO_"),
);

/** Multi-line postal address block, as required in the Imprint. */
export function addressHtml(): string {
  return [
    LEGAL.tradingName,
    LEGAL.entityName,
    LEGAL.street,
    `${LEGAL.postalCode} ${LEGAL.city}`,
    LEGAL.country,
  ].join("<br>");
}
